import { createDomicilioStreetText } from "app/main/address/models/DomicilioGoogle";

import { ResumeComponent } from "../pages/ReservationClientPrivateCreatePage";

export const ReservationClientPrivateResumeComponent: ResumeComponent = ({
  resume,
  actions,
}) => {
  const { passanger } = resume;
  return (
    <div>
      <div className="rounded-lg border-2 border-dashed border-gray-200 bg-gray-50 p-8">
        <div className="flex justify-between">
          {passanger ? (
            <div>
              <h1 className="font-bold">{passanger.name}</h1>
              <p className="text-typo-800 text-xs">{passanger.email}</p>
              <p className="text-typo-800 text-xs">{passanger.phone}</p>
            </div>
          ) : (
            <h1 className="font-bold">Viaje Personal</h1>
          )}
          <div className="flex flex-col items-end gap-2">
            <div className="bg-primary-500 rounded-full py-2 px-4 text-sm text-white">
              {resume.serviceType}
            </div>
          </div>
        </div>

        <p className="mt-6 mb-4 text-sm">{resume.reservationDateTime}</p>

        <ul className="list-inside list-decimal">
          {resume.itinerary.map((point, index) => (
            <li className="text-sm" key={index}>
              {createDomicilioStreetText(point.address)},{" "}
              {point.address.localidad}
            </li>
          ))}
        </ul>
      </div>
      <div className="mt-8">{actions}</div>
    </div>
  );
};
